export type LangCode = 'cs' | 'sk' | 'en';

export const INZERENT_TYPES: { value: string; label: string }[] = [
  { value: 'casino', label: 'Casino' },
  { value: 'sportsbook', label: 'Sportsbook' },
  { value: 'loterie', label: 'Loterie' },
  { value: 'kombinace', label: 'Kombinace' },
];

export function inzerentTypeLabel(value: string | null | undefined): string | null {
  return INZERENT_TYPES.find((t) => t.value === value)?.label ?? value ?? null;
}

export const INZERENT_SERVICES: { value: string; label: string }[] = [
  { value: 'affiliate_service', label: 'Affiliate service' },
  { value: 'land_based_affiliate', label: 'Land based Affiliate' },
  { value: 'pozvanka', label: 'Pozvánka' },
];

export function inzerentServiceLabels(values: string[] | null | undefined): string[] {
  const picked = new Set(values ?? []);
  return INZERENT_SERVICES.filter((s) => picked.has(s.value)).map((s) => s.label);
}

export interface LangDef {
  code: LangCode;
  label: string;
  flag: string;
  fullName: string;
}

export const LANGS: LangDef[] = [
  { code: 'cs', label: 'CZ', flag: '🇨🇿', fullName: 'Čeština' },
  { code: 'sk', label: 'SK', flag: '🇸🇰', fullName: 'Slovenčina' },
  { code: 'en', label: 'EN', flag: '🇬🇧', fullName: 'English' },
];

export function langDef(code: string | null | undefined): LangDef | null {
  if (!code) return null;
  return LANGS.find((l) => l.code === code.toLowerCase()) ?? null;
}

export const COMM_LANGS: { code: string; label: string }[] = [
  { code: 'cs', label: '🇨🇿 CZ' },
  { code: 'sk', label: '🇸🇰 SK' },
  { code: 'en', label: '🇬🇧 EN' },
  { code: 'es', label: '🇪🇸 ES' },
];

export function commLangLabel(code: string | null | undefined): string | null {
  if (!code) return null;
  return COMM_LANGS.find((l) => l.code === code.toLowerCase())?.label ?? code.toUpperCase();
}
